/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { getInfoCustomerApi, requestOtpNewPhoneApi, requestOtpPhoneExistApi, updateInfoCustomerApi, verifyOtpApi } from './helpers';
import { GetInfoCustomerDone } from './action';
import { GET_INFO_CUSTOMER, REQUEST_OTP_NEW_PHONE, REQUEST_OTP_PHONE_EXIST, UPDATE_INFO_CUSTOMER, VERIFY_OTP_PHONE } from './constant';

function* takeGetInfoCustomerSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getInfoCustomerApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(GetInfoCustomerDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostRequestOtpPhoneExistSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(requestOtpPhoneExistApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostRequestOtpNewPhoneSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(requestOtpNewPhoneApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostVerifyPhoneOtpSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(verifyOtpApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateInfoCustomerSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(updateInfoCustomerApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Đã xảy ra lỗi.");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_INFO_CUSTOMER, takeGetInfoCustomerSaga);
  yield takeLatest(REQUEST_OTP_PHONE_EXIST, takePostRequestOtpPhoneExistSaga);
  yield takeLatest(REQUEST_OTP_NEW_PHONE, takePostRequestOtpNewPhoneSaga);
  yield takeLatest(VERIFY_OTP_PHONE, takePostVerifyPhoneOtpSaga);
  yield takeLatest(UPDATE_INFO_CUSTOMER, takePostUpdateInfoCustomerSaga);
}

